import { Marker as MapboxMarker } from "react-map-gl";
import { Flex } from "@chakra-ui/react";
import { Coordinate, Spot } from "~/generated/graphql.types";
import { useState } from "react";
import { SpotOrderBadge } from "../../../../_shared/SpotOrderBadge";
import { SpotParamsFragment } from "~/routes/_shared/fragments.generated";

export const SpotMarker = ({
  spot,
  draggable = true,
  onClick = () => {},
  onDragEnd = () => {},
  label,
  isSelected,
}: {
  spot: Spot | SpotParamsFragment;
  draggable?: boolean;
  onClick?: () => void;
  onDragEnd?: (coord: Coordinate) => void;
  label: string;
  isSelected: boolean;
}) => {
  const [afterDrag, setAfterDrag] = useState(false);
  return (
    <MapboxMarker
      data-testid={"spot-marker"}
      draggable={draggable}
      onDragEnd={(e) => {
        onDragEnd({
          lat: e.lngLat.lat,
          lon: e.lngLat.lng,
        });
        setAfterDrag(true);
      }}
      onClick={() => {
        onClick();
      }}
      latitude={spot.coordinate.lat}
      longitude={spot.coordinate.lon}
      style={{ zIndex: 100 }}
    >
      <Flex position="relative" bottom={4} zIndex={200}>
        <SpotOrderBadge
          label={label}
          spot={spot}
          isSelected={isSelected}
          pointer
        />
      </Flex>
    </MapboxMarker>
  );
};
